<script lang="ts">
    import { IFormItemConfiguration } from '@/components/atoms/form/entities/form-item-configuration.interface';
    import { IconName } from 'webshop-modules';
    import IconComponent from '../../Icon.vue';
    import { Component, Prop, Emit, Vue } from 'vue-facing-decorator';

    @Component({
        components: { IconComponent },
        name: 'FormField',
    })
    export default class FormField extends Vue {
        @Prop({ required: true })
        public config!: IFormItemConfiguration;

        @Prop({ required: true })
        public placeholderState!: boolean;

        @Prop({ required: true })
        public errorState!: boolean;

        @Emit()
        public submitAction(event: Event): Event | undefined {
            event.preventDefault();

            if (this.config.inlineSubmit) {
                return event;
            }
        }

        public get isTranslationLabel(): boolean {
            return typeof this.config.label !== 'string';
        }

        public readonly IconName: typeof IconName = IconName;
    }
</script>

<template>
    <div
        class="a-formField"
        v-bind:class="{
            '-has-error': errorState,
            '-is-fullwidth': config.fullwidth,
        }">
        <transition name="fade">
            <template v-if="config.label && placeholderState">
                <label
                    v-if="isTranslationLabel"
                    v-translate="config.label"
                    :for="config.name"
                    class="a-formField__placeholder"></label>
                <label
                    v-else
                    :for="config.name"
                    class="a-formField__placeholder"
                    >{{ config.label }}</label
                >
            </template>
        </transition>

        <div
            v-if="config.inlineSubmit"
            v-on:click="submitAction"
            class="a-formField__action">
            <IconComponent :icon-id="IconName.ArrowFull" />
        </div>

        <slot></slot>
    </div>
</template>
